/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusEmailEmpfaengerDto } from '../../models/lexplus-email-empfaenger-dto';

export interface EmailTemplateControllerFindRecipientsV1$Params {
  suche?: string;
  gruppe?: 'meine-kunden' | 'newsletter-abonnenten';
}

export function emailTemplateControllerFindRecipientsV1(http: HttpClient, rootUrl: string, params?: EmailTemplateControllerFindRecipientsV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LexplusEmailEmpfaengerDto>>> {
  const rb = new RequestBuilder(rootUrl, emailTemplateControllerFindRecipientsV1.PATH, 'get');
  if (params) {
    rb.query('suche', params.suche, {});
    rb.query('gruppe', params.gruppe, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LexplusEmailEmpfaengerDto>>;
    })
  );
}

emailTemplateControllerFindRecipientsV1.PATH = '/v1/email-templates/empfaenger';
